import { UNKNOWN_GENDER_ID, UNKNOWN_LABEL } from '@app/constants';

import type { BaseOptionType } from 'antd/es/select';

export const RUSSIAN_ID = 'ruRu';
export const ENGLISH_ID = 'enUs';

export const RUSSIAN = 'Русский';
export const ENGLISH = 'Английский';

export const LANGUAGE: BaseOptionType[] = [
  {
    label: UNKNOWN_LABEL,
    value: UNKNOWN_GENDER_ID,
  },
  {
    label: RUSSIAN,
    value: RUSSIAN_ID,
  },
  {
    label: ENGLISH,
    value: ENGLISH_ID,
  },
];
